<template>
	<div>
		<h1>{{ $t('gerirUtilizadores') }}</h1>      

		<div class="my-5 w-full">
			<div class="flex items-end w-full">
			
				<!-- Grupo: Input + Botões Filtrar/Todos -->
				<div class="flex items-end space-x-2 flex-grow px-1">
					<div class="flex-grow max-w-lg">
						<vs-input class="w-full"
						@keyup.enter.native="getUserInfo(user_id)"
						v-bind:label="$t('insertUserId')"
						v-model="user_id" />
					</div>
					<vs-button class="ml-1" color="primary" type="filled" @click="getUserInfo(user_id)">Filtrar</vs-button>
					<vs-button class="ml-1" color="primary" type="filled" @click="getUserInfo(0)">Todos</vs-button>
				</div>

				<!-- Botão Novo isolado à direita -->
				<div class="px-1">
					<vs-button color="primary" type="filled" @click="showPopup(null)">Novo</vs-button>
				</div>

			</div>
		</div>
		
		<vs-popup class="introduction_popup" v-bind:title="set_new_user ? 'Nova permissão' : 'Editar permissão'" :active.sync="popupActivo">

			<div>
				<div v-show="set_new_user == true">
					<v-select id="user_to_add" v-model="selectedUser" :append-to-body="true" @search="query => search_new_user = query" label="label" @input="setUser" :options="filtered_users">
					<span slot="no-options">{{$t('vSelectNoResults')}}</span>
					</v-select>
					<br />
				</div>
				ID: {{user_selected.cod_pessoa}}
				<br/><br/>
				Nome: {{user_selected.nome}}
				<br/><br/>
				<div class="flex flex-wrap">
					{{ $t('roleActual') }}: 
					<UserRoleDropdown class="ml-2 -mt-2" v-bind:roles="roles" :user="user_selected" v-on:roleUpdate="updateRole"/>
				</div>
			</div>

			<div class="element_button mt-5">
				<div class="submit_button">
					<vs-button v-if="set_new_user != false" color="primary" class="" type="filled" @click="addUser">{{ $t('Gravar') }}</vs-button>
					<vs-button v-if="set_new_user == false" color="primary" class="" type="filled" @click="changeRole">{{ $t('Gravar') }}</vs-button>
					<vs-button v-if="set_new_user == false" color="danger" class="ml-2" type="filled" @click="removeRole(user_selected.user_id)">Eliminar</vs-button>
				</div>
			</div>
		</vs-popup>

	    <div class="user_info_table" v-if="users_info.length > 0">
			<vs-table stripe :data="users_info">
				  <template slot="thead">
						<vs-th>
							Id
						</vs-th>
						<vs-th>
						    Nome
						</vs-th>
						<vs-th>
							Email
						</vs-th>
						<vs-th>
							Nível
						</vs-th>
						<vs-th>
						</vs-th>
					</template>	

					<template slot-scope="{data}">
						<vs-tr :key="index" v-for="(user, index) in data" >
							<vs-td>
								{{user.person_id}}
							</vs-td>

							<vs-td>
								{{user.nome}}
							</vs-td>

							<vs-td>
								{{user.email}}
							</vs-td>

							<vs-td>
								{{user.role_name}}
							</vs-td>
						  
							<vs-td>
								<div class="edit_button" style="cursor: pointer;" @click="showPopup(user)"><EditIcon></EditIcon></div>
							</vs-td>
						</vs-tr>
					</template>
			</vs-table>
		</div>
	</div>
</template>

<script>

import { EditIcon } from 'vue-feather-icons'

import UserRoleDropdown from '@/views/components/UserRoleDropdown.vue'

import Fuse from 'fuse.js';

export default {
  data(){
	return {
		current_search: '',
		user_id: '',
		users_info: [],
		roles: [],
		search_new_user: '',
		popupActivo: false,
		user_selected: {
			cod_pessoa: '',
			nome: '',
			email: ''
		},
		selectedUser: null,
		newRole: false,
		update_role_msg: '',
		set_new_user: false,
		users: [],
		logged_user: JSON.parse(window.localStorage.getItem('userSession'))
	} 
  },
  methods: {
	setUser(value = null) {
		if(value == null) {
			this.user_selected = {
				cod_pessoa: '',
				nome: '',
				role_id: '',
				email: ''
			};
			this.selectedUser = null;
		}else{
			this.user_selected = {
				cod_pessoa: value.cod_pessoa,
				nome: value.nome,
				role_id: '',
				email: value.email
			};
		}
		this.search_new_user = '';
	},
	changeFilter(options, search) {

		const fuse = new Fuse(options, {
			keys: ['nome', 'cod_pessoa'],
			shouldSort: true,
			threshold: 0.1
		});

		let result = [];

		const result_searche = fuse.search(search).forEach(x => {
			result.push(x.item);
		});

      	return search.length > 0 ? result : fuse.list;
    },
	removeRole(user_id) {
		this.$vs.loading();

		let that = this;
			
			let token = localStorage.getItem('usertoken');

			this.$api({
				method: 'post',
				url: '/myvilagale/user/removemsrole',
				params: {
					token: token,
					userId: user_id,
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then(function (res) {
				that.notify('Registo removido com sucesso.', 'green', 5);
				that.popupActivo = false;
				that.getUserInfo(0);
				that.getUsers();
				that.$vs.loading.close();
			}) 
			.catch( function (err) {
				that.$vs.notify({
					text: '“Ocorreu um erro ao eliminar o registo.',
					color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
				});
				that.$vs.loading.close();
			});

	},

	showPopup(person) {
		if (person == null) {
			this.set_new_user = true;
		} else {
			this.set_new_user = false;
			this.user_selected = person;
			this.user_selected.cod_pessoa = person.person_id;
		}

		this.popupActivo = true;
	},
	updateRole(newRole) {
		this.newRole = true;
	},
	changeRole() {
		this.$vs.loading();
		let that = this;

		if (this.newRole) {
			
			let token = localStorage.getItem('usertoken');

			this.$api({
				method: 'post',
				url: '/myvilagale/user/updatemsrole',
				params: {
					token: token,
					userId: that.user_selected.user_id,
					newRole: that.user_selected.role_id,
					responsibleId: that.logged_user.id
				},
				headers: {
					Authorization: 'Bearer ' + token
				}
			})
			.then(function (res) {
				that.$vs.notify({
					text: 'Registo alterado com sucesso.',
					color:'success',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-check'
				});
				that.popupActivo = false;
				let new_role_desc = that.roles.find((item, idx) => item.role_id == that.user_selected.role_id);
				that.user_selected.role_name = new_role_desc.description;
				that.getUserInfo(0);
				that.$vs.loading.close();
			}) 
			.catch( function (err) {
				that.$vs.notify({
                    text: 'Ocorreu um erro ao alterar o registo.',
                    color:'danger',
					position:'bottom-right',
					iconPack: 'feather',
					icon:'icon-alert-triangle'
                });
			})
			.then(function() {
				that.$vs.loading.close();
			});

		}
	},
	addUser() {
		if (!this.newRole) {
			this.$vs.notify({
				text: 'Por favor escolha uma permissão.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});

			return false;
		}

		if (!this.user_selected.cod_pessoa) {
			this.$vs.notify({
				text: 'Por favor escolha um utilizador.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});

			return false;
		}

		this.$vs.loading();
		let that = this;
		
		let token = localStorage.getItem('usertoken');

		this.$api({
			method: 'post',
			url: '/myvilagale/user/setmsrole',
			params: {
				token: token,
				userId: that.user_selected.cod_pessoa,
				newRole: that.user_selected.role_id,
				responsibleId: that.logged_user.id
			},
			headers: {
				Authorization: 'Bearer ' + token
			}
		})
		.then(function (res) {
			that.$vs.notify({
				text: 'Registo criado com sucesso.',
				color:'success',
				position:'top-right',
				iconPack: 'feather',
				icon:'icon-check'
			});
			that.popupActivo = false;
			let new_role_desc = that.roles.find((item, idx) => item.role_id == that.user_selected.role_id);
			that.user_selected.role_name = new_role_desc.description;
			that.getUserInfo(0);
			that.getUsers();
			that.setUser(null);
			that.$vs.loading.close();
		}) 
		.catch( function (err) {
			that.$vs.notify({
				text: 'Ocorreu um erro ao criar o registo.',
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});
		})
		.then(function() {
			that.$vs.loading.close();
		});
	},
	getUserInfo(user_id) {
		if (user_id.length == 0) {
			this.$vs.notify({
				text: this.$t('empty_search_filed'),
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});
			
			return false;
		}

		this.$vs.loading();

		let that = this;
		
		//fetch user info
		let token = localStorage.getItem('usertoken');

		this.$api({
			method: 'get',
			url: '/myvilagale/user/msinfo',
			params: {
				token: token,
				id: user_id,
			},
			headers: {
				Authorization: 'Bearer ' + token
			}
		})
		.then(function (res) {			
			let info = [
				{
					"id" : res.data.id,
					"nome" : res.data.name,
					"role" : res.data.description,
					"email" : res.data.email,
				}	
			];
			that.user_id = '';
			that.$vs.loading.close();
			that.users_info = res.data;
		}) 
		.catch( function (err) {
			that.$vs.loading.close();
			that.$vs.notify({
				text: that.$t('user_not_found'),
				color:'danger',
				position:'bottom-right',
				iconPack: 'feather',
				icon:'icon-alert-triangle'
			});
		})
	  },

	  getUsers(search) {
		  this.$vs.loading();

		  let that = this;	
		  let token = localStorage.getItem('usertoken');
		
		  this.$api({
			method: 'get',
			url: '/myvilagale/users',
			params: {
				token: token,
				search: search
			},
			headers: {
				Authorization: 'Bearer ' + token
			}
		})

		.then(function (res) { 
			that.$vs.loading.close();
			that.users = res.data;
		}).catch( function (err) {
			that.$vs.loading.close();
		})
	  }
    },
    computed: {
    	filtered_users: function() {
    		if(this.search_new_user.length > 2) {
    			return this.users.filter((item, idx) => item.nome.toLowerCase().indexOf(this.search_new_user.toLowerCase()));
    		}
    		return [];
    	}
    },
	watch: {
		'popupActivo': function (newVal, oldVal) {
			if(!newVal) {
				this.user_selected = {
					cod_pessoa: '',
					role_id: '',
					nome: ''
				}
				this.update_role_msg = '';
				this.search_new_user = '';
			}
		}
	},
	mounted() {
		this.getUsers();
		this.getUserInfo(0);	
	},
    components: { EditIcon, UserRoleDropdown },
    created: function() {
    	let that = this;	
	    let token = localStorage.getItem('usertoken');

		this.$api({
			method: 'get',
			url: '/myvilagale/user/roles',
			params: {
				token: token
			},
			headers: {
				Authorization: 'Bearer ' + token
			}
		})

		.then(function (res) { 
			that.roles = res.data;
		}).catch( function (err) {
		});
    }
}

</script>

<style>

</style>
